import Courses from '@/api/course';
import CourseView from '@/views/CourseView.vue';

export const COURSES_ROUTE = [
  {
    path: `/${Courses.SLUG}/`,
    name: `${Courses.SLUG}-list`,
    component: CourseView,
    props: () => ({
      entity: Courses.SLUG
    }),

    meta: {
      title: 'Courses · ELSA Content Creator'
    }
  },
  {
    path: `/${Courses.SLUG}/new`,
    name: `${Courses.SLUG}-new`,
    component: CourseView,
    props: () => ({
      entity: Courses.SLUG,
      isNew: true,
      isEdit: true
    }),

    meta: {
      title: 'New Courses · ELSA Content Creator'
    }
  },
  {
    path: `/${Courses.SLUG}/:id(\\d+)`,
    name: `${Courses.SLUG}-edit`,
    component: CourseView,
    props: (route) => ({
      entity: Courses.SLUG,
      id: parseInt(route.params.id, 10),
      isEdit: true
    }),
    meta: {
      title: 'Edit Courses · ELSA Content Creator'
    }
  }
];
